import { DEFAULT_SLIDESHOW_TRANSITION } from 'ts/common/components/slideshows/slideshowTransitions';

export const SLIDESHOW_DEFAULTS = {
    aspectRatio: '16:9',
    slide: {
        duration: 3000,
        transition: DEFAULT_SLIDESHOW_TRANSITION,
        transitionDuration: 1000,
        backgroundColor: '#000000'
    },
    item: {
        rotation: 0,
        positionX: 0,
        positionY: 0,
        width: 100,
        height: 100
    }
} as const;
